import { categoryRepository } from '~/api/repository/category';

export const CATEGORY_QUERY_KEY = {
  all: ['category'] as const,

  // 전시 카테고리 트리 조회 (useOAIQuery와 동일한 queryKey 사용)
  tree: () => ({
    queryKey: ['/api/market-place/v1/display-categories'] as const,
    queryFn: () => categoryRepository.getCategoryTree(),
  }),
};
